import '../../../_virtual/lodash.js';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import 'vue';
import { NodeUtils } from '../../../util/node-utils.js';
import { PARAGRAPH_TYPE } from './constant.js';
import '@ssml-editor/core';

const paragraphPlugin = (editor) => {
  const { isInline, isVoid } = editor;
  const newEditor = editor;
  newEditor.isInline = (element) => {
    const type = NodeUtils.getNodeType(element);
    if (type === PARAGRAPH_TYPE) return false;
    return isInline(element);
  };
  newEditor.isVoid = (element) => {
    const type = NodeUtils.getNodeType(element);
    if (type === PARAGRAPH_TYPE) return false;
    return isVoid(element);
  };
  return newEditor;
};

export { paragraphPlugin };
//# sourceMappingURL=plugin.js.map
